import React from 'react';
import { useTranslation } from 'react-i18next';

// Styles
import styles from './index.module.sass';

const BackButton = (props) => {
  const { history } = props;
  const { t } = useTranslation('global');
  return (
    <div id={styles.BackButton} onClick={() => history.push('/cart/consultancy/panel/')}>
      {t('backButton')}
    </div>
  );
};

export default BackButton;
